<div class="content-wrapped">
    <!-- Content -->
    <div class="container-xxl flex-grow-1 container-p-y">
        <div class="project-config-container">
            <h2 class="fw-bold py-3 mb-4 text-primary">
                <mat-icon class="me-2 align-middle">edit</mat-icon>Configuración - {{project?.nombre}}
            </h2>
            <div class="button-group">
              <!--<button mat-raised-button color="primary">Configuración de Inventarios</button>-->
              <!--<button mat-raised-button color="accent">Diagramación</button>-->
            </div>
        
            <div>
                <h5 class="fw-bold py-3 mb-4 text-primary"><mat-icon class="me-2 align-middle"> edit_attributes</mat-icon>Configuración de Vistos Buenos:</h5>
            </div>
            <div class="button-group d-flex align-items-center mb-4">
             <button *ngIf="hasPermissions('save_conf_vobos',null,true)" class="same-height" mat-raised-button color="accent" (click)="ruSure()">Guardar</button>

             <button *ngIf="hasPermissions('copy_conf_vobos',null,true) && !hasDiagramas" class="same-height" mat-raised-button (click)="openCloneProyect()" color="primary">Copiar Configuración</button>
             <button *ngIf="hasPermissions('reorder_phases',null,true)" class="same-height" mat-raised-button (click)="openReorderPhases()" color="primary">Reordenar fases</button> 
             <button *ngIf="hasPermissions('add_phase_vobos',null,true)" class="same-height" mat-raised-button (click)="addPhase()" color="primary"><mat-icon>add</mat-icon> Añadir nueva fase</button> 
             </div>
             <!--<div class="me-5">
              <mat-form-field appearance="outline" class="form-field same-height w-30">
                <mat-label>Usuarios para carga de Artes</mat-label>
                <mat-select [(ngModel)]="user_selected" multiple (closed)="clearUserSearch()">
                  <div class="search-option">
                    <div class="search-input-container mat-form-field-outlined">
                      <mat-icon class="search-icon" aria-hidden="true">search</mat-icon>
                      <input #searchInput matInput [(ngModel)]="userSearchTerm" (ngModelChange)="filterUsers()" (click)="$event.stopPropagation()" placeholder="Buscar usuario">
                    </div>
                  </div>
                    <button  mat-flat-button (click)="toggleAllUsers()" ><mat-icon>library_add</mat-icon>{{ areAllFilteredUsersSelected() ? 'Quitar todos' : 'Seleccionar todos' }}</button>
                  <mat-option *ngFor="let user of filteredUsers" [value]="user.id">{{user.name}}</mat-option>
                </mat-select>
               </mat-form-field>
             </div>-->

              <div class="alert alert-danger" role="alert" *ngIf="haschanges">
                *Hay cambios pendientes sin guardar
              </div>
              <div class="pb-3">
                <b>Fecha Final: </b> {{ fecha_final | date : "dd/MM/yyyy" : "+0600" }}
              </div>
            <div class=" row">
              <div class="col-sm-4" *ngFor="let phase of dataPhases" [hidden]="phase.deleted == 1">
                <mat-card >
                  <div class="d-flex justify-content-between align-items-center">
                    <mat-card-title>{{ phase.nombre }}</mat-card-title>
           
                    <div class="text-secondary">
                        <span>Límite de arte: {{ phase.scheluded_time_days }} días</span>
                    </div>
                    <button *ngIf="hasPermissions('del_phase',null,true) && !hasDiagramas" style="right: -20px;" mat-icon-button matTooltip="Eliminar" (click)="removeItem(phase)"><mat-icon mat-tooltip="Editar">remove</mat-icon></button>
                    <button *ngIf="hasPermissions('edit_phase',null,true)" mat-icon-button matTooltip="Editar" (click)="editPhase(phase)"><mat-icon mat-tooltip="Editar">edit</mat-icon></button>
                </div>
                  <mat-divider></mat-divider>
                  <div cdkDropList (cdkDropListDropped)="drop(phase.vobos, $event)">
                    <mat-list>
                      <mat-list-item *ngFor="let item of phase.vobos" [hidden]="item.deleted == 1" cdkDrag>
                          <button *ngIf="hasPermissions('del_vobo',null,true)" mat-icon-button matTooltip="Eliminar" (click)="removeItem(item)"><mat-icon >remove</mat-icon></button>
                          <button *ngIf="hasPermissions('edit_vobo',null,true)" mat-icon-button matTooltip="Editar" (click)="openAddEditVobo(item,  phase.vobos)"><mat-icon mat-tooltip="Editar">edit</mat-icon></button>
                        <div mat-line>Área: {{ item.area }}</div>
                        <div mat-line>Días programados: {{ item.scheluded_time_days }}</div>
                        <div mat-line>Usuarios seleccionados: {{ item.users?.length }}</div>
                        <div mat-line>Validaciones en formulario: {{ item.vobos?.length }}</div>
                        <div *ngIf="item.optional == 1" mat-line><b>Opcional</b></div>
                      </mat-list-item>
                    </mat-list>
                  </div>
                  <mat-list>
                      <mat-list-item>
                          <button *ngIf="hasPermissions('add_vobo',null,true)" mat-flat-button color="secundary" (click)="addItem(phase.vobos)"><mat-icon>add</mat-icon> Añadir nuevo VoBo </button>
                        </mat-list-item>
                  </mat-list>
                </mat-card>
              </div>

              <!--<div class="col-sm-4">
                <mat-card>
                  <mat-card-title>Fase de Artes</mat-card-title>
                  <mat-divider></mat-divider>
                  <div cdkDropList (cdkDropListDropped)="drop(artesItems, $event)">
                    <mat-list>
                      <mat-list-item *ngFor="let item of artesItems" [hidden]="item.deleted == 1" cdkDrag>
                      <button mat-icon-button matTooltip="Eliminar" (click)="removeItem(item)"><mat-icon >remove</mat-icon></button>
                      <button mat-icon-button matTooltip="Editar" (click)="openAddEditVobo(item)"><mat-icon mat-tooltip="Editar">edit</mat-icon></button>
                        <div mat-line>Responsable: {{ item.responsable }}</div>
                        <div mat-line>Días programados: {{ item.scheluded_time_days }}</div>
                      </mat-list-item>
                    </mat-list>
                  </div>
                  <mat-list>
                      <mat-list-item>
                          <button mat-flat-button color="secondary" (click)="addArtes()"><mat-icon>add</mat-icon> Añadir nuevo VoBo </button>
                        </mat-list-item>
                  </mat-list>
                </mat-card>
              </div>-->


              <!--<div class="col-sm-4">
                <mat-card>
                  <button mat-flat-button color="secondary" (click)="addPhase()"><mat-icon>add</mat-icon> Añadir nueva fase</button>
                </mat-card>
              </div>-->
            </div>
          </div>
    </div>
</div>
